export default function menu({ variables }) {
    return {
        MuiMenu: {
            styleOverrides: {
                root: {
                    zIndex: 100000,
                },
                paper: {
                    border: `1px solid ${variables.border_subtle}`,
                    borderRadius: variables.border_radius_small,
                },
                list: {
                    paddingTop: variables.spacing_02,
                    paddingBottom: variables.spacing_02,
                    "&& .MuiDivider-root": {
                        marginTop: variables.spacing_03,
                        marginBottom: variables.spacing_03,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=menu.js.map